<template>
  <v-text-field
    :label="item.label"
    :value="computedValue"
    readonly
    :disabled="!updateTrigger || disabled"
    v-if="showItem"
  >
    <template v-slot:prepend>
      <span v-if="item.required" class="red--text">*</span>
    </template>
  </v-text-field>
</template>

<script>
import _ from "lodash";
/* eslint-disable */
export default {
  name: "calcolato",
  props: {
    item: Object, // deve contenere .label, .formula, etc.
    appoggio: Object, // locProdotto
    disabled: { type: Boolean, default: false },
    updateTrigger: { type: Number, default: 1 },
    defaultUsed: { type: Boolean, default: false },
  },
  computed: {
    showItem() {
      if (this.item && this.item.showIf) {
        return _.get(this, this.item.showIf, false);
      } else if (this.item && this.item.hideIf) {
        return !_.get(this, this.item.hideIf, false);
      } else {
        return true;
      }
    },
    computedValue() {
      try {
        const op1 = parseFloat(_.get(this.appoggio, this.item.op1, 0));
        const op2 = parseFloat(_.get(this.appoggio, this.item.op2, 0));
        const iva = parseFloat(_.get(this.appoggio, 'datiFiscali.aliquoteIva[0].valore', 0));
        const operazione = this.item.operazione;
        switch (operazione) {
          case "somma":
            return op1 + op2;
          case "sottrazione":
            return op1 - op2;
          case "moltiplicazione":
            return op1 * op2;
          case "divisione":
            return op1 / op2;
          case "percentuale di ricarico":
            if (op1 && op2) {
              const prezzoVendita = op1
              const prezzoAcquisto = op2 + (iva/100*op2)
              const calcolo = 100 * (prezzoVendita / prezzoAcquisto - 1);
              return calcolo % 1 === 0
                ? calcolo + "%"
                : calcolo.toFixed(2) + "%";
            }
          default:
            return "";
        }
      } catch (err) {
        console.error("Errore calcolo campo:", err);
        return "";
      }
    },
  },
};
</script>
